import { routes } from 'utils/routing';
import { MARKETS_SLUGS_MAP } from 'utils/transform';

import { EventPromoCardType } from './EventPromoCardsContainer';

type EventsPromoType = Record<string, EventPromoCardType[]>;

const isTestEnv = () => process.env.NEXT_PUBLIC_BUILD_ENV === 'test';

const promoColors = {
  a: '#7F9BEF',
  b: '#7AA6E9',
  c: '#868BF4',
  d: '#72ADD7',
};

export const getPath = (slug: string, filters: any = {}) =>
  routes.events({
    market_slug: MARKETS_SLUGS_MAP[slug as keyof typeof MARKETS_SLUGS_MAP],
    exclude_hidden_events: true,
    ordering: 'session_date',
    ...filters,
  });

export const mainBanner = (market: string) => {
  if (market === 'miami')
    return {
      sm: '/static/img/homepage-banner-miami-sm.png',
      lg: '/static/img/homepage-banner-miami-lg.png',
    };
  return {
    sm: '/static/img/homepage-banner-sm.png',
    lg: '/static/img/homepage-banner-lg.png',
  };
};

export const eventsPromo = (): EventsPromoType => {
  const cincinnatiEvents = [
    {
      backgroundImage: '/static/img/promo-cards/teens.png',
      backgroundColor: promoColors.a,
      route: routes.teenEvents('cincinnati'),
      title: 'teenEvents',
    },
    {
      backgroundImage: '/static/img/promo-cards/young-adults-events-cincinnati.png',
      backgroundColor: promoColors.b,
      route: routes.youngAdultEvents('cincinnati'),
      title: 'youngAdultsEvents',
    },
    {
      backgroundImage: '/static/img/promo-cards/family-events-cincinnati.png',
      objectPosition: 'top',
      backgroundColor: promoColors.c,
      route: routes.familyEvents('cincinnati'),
      title: 'familyEvents',
    },
    {
      backgroundImage: '/static/img/promo-cards/older-adults.png',
      backgroundColor: promoColors.d,
      route: routes.olderAdults('cincinnati'),
      title: 'olderAdultsEvents',
    },
  ];
  const detroitEvents = [
    {
      backgroundImage: '/static/img/promo-cards/purim-events-detroit.jpg',
      backgroundColor: promoColors.a,
      route: routes.jewishHolidaysEvents('detroit'),
      title: 'jewishHolidaysEvents',
    },
    {
      backgroundImage: '/static/img/promo-cards/young-adults-events-detroit.jpg',
      backgroundColor: promoColors.b,
      route: routes.youngAdultEvents('detroit'),
      title: 'youngAdultsEvents',
    },
    {
      backgroundImage: '/static/img/promo-cards/family-events-detroit.jpg',
      objectPosition: 'top',
      backgroundColor: promoColors.c,
      route: routes.familyEvents('detroit'),
      title: 'familyEvents',
    },
    {
      backgroundImage: '/static/img/promo-cards/events-for-seniors.png',
      backgroundColor: promoColors.d,
      route: routes.eventsForSeniors('detroit'),
      title: 'eventsForSeniors',
    },
  ];
  const montrealEvents = [
    {
      backgroundImage: '/static/img/promo-cards/purim-events-detroit.jpg',
      backgroundColor: promoColors.a,
      route: routes.jewishHolidaysEvents('montreal'),
      title: 'jewishHolidaysEvents',
    },
    {
      backgroundImage: '/static/img/promo-cards/young-adults-events-montreal.jpg',
      backgroundColor: promoColors.b,
      route: routes.youngAdultEvents('montreal'),
      title: 'youngAdultsEvents',
    },
    {
      backgroundImage: '/static/img/promo-cards/family-events-montreal.jpg',
      backgroundColor: promoColors.c,
      route: routes.familyEvents('montreal'),
      title: 'familyEvents',
    },
    {
      backgroundImage: '/static/img/promo-cards/all-events.jpg',
      backgroundColor: promoColors.d,
      route: routes.events({
        market_slug: MARKETS_SLUGS_MAP.montreal,
        exclude_hidden_events: true,
        ordering: 'session_date',
      }),
      title: 'allEvents',
    },
  ];

  const annArborEvents = [
    {
      backgroundImage: '/static/img/banners/arts.png',
      backgroundColor: promoColors.a,
      route: routes.artsAndCulture('ann-arbor'),
      title: 'artsAndCulture',
    },
    {
      backgroundImage: '/static/img/banners/education.png',
      backgroundColor: promoColors.b,
      route: routes.educationAndLearning('ann-arbor'),
      title: 'educationAndLearning',
    },
    {
      backgroundImage: '/static/img/banners/family-programs.png',
      backgroundColor: promoColors.c,
      route: routes.familyPrograms('ann-arbor'),
      title: 'familyPrograms',
    },
    {
      backgroundImage: '/static/img/banners/social-events.png',
      backgroundColor: promoColors.d,
      route: routes.socialEvents('ann-arbor'),
      title: 'socialEvents',
    },
  ];

  const northernVirginiaEvents = [
    {
      backgroundImage: '/static/img/promo-cards/JewishHolidayEvents_800x460.jpg',
      backgroundColor: promoColors.c,
      route: routes.jewishHolidaysEvents('northern-virginia'),
      title: 'jewishHolidaysEvents',
    },
    {
      backgroundImage: '/static/img/promo-cards/EventsforAdults_800x460.jpg',
      backgroundColor: promoColors.d,
      route: routes.adultevents('northern-virginia'),
      title: 'adultEvents',
    },
    {
      backgroundImage: '/static/img/promo-cards/FamilyPrograms_family_800x460.jpg',
      objectPosition: 'top',
      backgroundColor: promoColors.a,
      route: routes.familyEvents('northern-virginia'),
      title: 'familyEvents',
    },
    {
      backgroundImage: '/static/img/promo-cards/AdultEducation_800x460.jpg',
      backgroundColor: promoColors.b,
      route: routes.education('northern-virginia'),
      title: 'education',
    },
  ];

  // Removing 1 element in order to have 3 elements on dev env only
  if (isTestEnv()) {
    montrealEvents.pop();
  }
  return {
    cincinnati: cincinnatiEvents,
    detroit: detroitEvents,
    montreal: montrealEvents,
    'ann-arbor': annArborEvents,
    'northern-virginia': northernVirginiaEvents,
  };
};

export const bannerData = {
  cincinnati: [
    {
      mobileImage: '/static/img/banners/jewish-holidays-cincinnati-1090x400.png',
      desktopImage: '/static/img/banners/jewish-holidays-cincinnati-1090x400.png',
      url: routes.jewishHolidaysEvents('cincinnati'),
      startAt: '01 Mar 2023',
    },
    // {
    //   mobileImage: '/static/img/banners/PRIDE_704x240.png',
    //   desktopImage: '/static/img/banners/PRIDE_704x240.png',
    //   url: routes.pridePage('cincinnati'),
    //   startAt: '01 Mar 2023',
    // },
    {
      mobileImage: '/static/img/banners/IsraelPrograms1090x400.png',
      desktopImage: '/static/img/banners/IsraelPrograms1090x400.png',
      url: {
        // eslint-disable-next-line max-len
        link: 'https://jlive.app/events?market_slug=cincinnati&market_slug=usa&market_slug=north-america&market_slug=international&exclude_hidden_events=true&ordering=session_date&category=55',
      },
      startAt: '01 Mar 2023',
    },
  ],
  detroit: [
    {
      mobileImage: '/static/img/banners/jobsDetroit_desktop.png',
      desktopImage: '/static/img/banners/jobsDetroit_desktop.png',
      url: routes.detroitJobs(),
      startAt: '01 Mar 2023',
    },
    {
      mobileImage: '/static/img/banners/volonteerDetroitBanner.png',
      desktopImage: '/static/img/banners/volonteerDetroitBanner.png',
      url: getPath('detroit', { type: isTestEnv() ? 94 : 115 }),
      startAt: '01 Mar 2023',
    },
    {
      mobileImage: '/static/img/banners/family_programming.png',
      desktopImage: '/static/img/banners/family_programming.png',
      url: routes.familyEvents('detroit'),
      startAt: '01 Mar 2023',
    },
  ],
  montreal: [
    {
      mobileImage: '/static/img/banners/montrealIsraelInCrisis_mobile.png',
      mobileImageFr: '/static/img/banners/montrealIsraelInCrisis_mobile_fr.png',
      desktopImage: '/static/img/banners/montrealIsraelInCrisis_desktop.png',
      desktopImageFr: '/static/img/banners/montrealIsraelInCrisis_desktop_fr.png',
      url: { link: 'https://jlive.app/e/montreal/supportisrael' },
      startAt: '01 Mar 2023',
    },
    {
      mobileImage: '/static/img/banners/montrealVolunteer_mobile_en.png',
      mobileImageFr: '/static/img/banners/montrealVolunteer_mobile_fr.png',
      desktopImage: '/static/img/banners/montrealVolunteer_en.png',
      desktopImageFr: '/static/img/banners/montrealVolunteer_fr.png',
      url: routes.volunteering('montreal'),
      startAt: '01 Mar 2023',
    },
  ],
};

export const tagsRows = {
  'ann-arbor': [
    {
      title: 'artsAndCulture',
      path: getPath('ann-arbor', { category: 2 }),
    },
    {
      title: 'israel',
      path: getPath('ann-arbor', { category: 55 }),
    },
    {
      title: 'jewishHolidays',
      path: getPath('ann-arbor', { category: 46 }),
    },
    {
      title: 'teens',
      path: getPath('ann-arbor', { target_age: 2 }),
    },
    {
      title: 'volunteerism',
      path: getPath('ann-arbor', { type: isTestEnv() ? 94 : 115 }),
    },
    {
      title: 'health-wellness',
      path: getPath('ann-arbor', { category: 52 }),
    },
    {
      title: 'history',
      path: getPath('ann-arbor', { category: 53 }),
    },
  ],
  montreal: [
    {
      title: 'teenEvents',
      path: getPath('montreal', { target_age: 2 }),
    },
    {
      title: 'parents',
      path: getPath('montreal', { target_age: 9 }),
    },
    {
      title: 'food',
      path: getPath('montreal', { category: 51 }),
    },
    {
      title: 'artsAndCulture',
      path: getPath('montreal', { category: 2 }),
    },
    {
      title: 'sportsAndFitness',
      path: getPath('montreal', { category: 63 }),
    },
    {
      title: 'israel',
      path: getPath('montreal', { category: 55 }),
    },
    {
      title: 'leadership',
      path: getPath('montreal', { category: 64 }),
    },
    {
      title: 'general',
      path: getPath('montreal', { category: 85 }),
    },
  ],
  detroit: [
    {
      title: 'artsAndCulture',
      path: getPath('detroit', { category: 2 }),
    },
    {
      title: 'israel',
      path: getPath('detroit', { category: 55 }),
    },
    {
      title: 'jewishHolidays',
      path: getPath('detroit', { category: 46 }),
    },
    {
      title: 'teens',
      path: getPath('detroit', { target_age: 2 }),
    },
    {
      title: 'volunteerism',
      path: getPath('detroit', { type: isTestEnv() ? 94 : 115 }),
    },
    {
      title: 'health-wellness',
      path: getPath('detroit', { category: 52 }),
    },
    {
      title: 'history',
      path: getPath('detroit', { category: 53 }),
    },
  ],
  cincinnati: [
    {
      title: 'artsAndCulture',
      path: getPath('cincinnati', { category: 2 }),
    },
    {
      title: 'israel',
      path: getPath('cincinnati', { category: 55 }),
    },
    {
      title: 'jewishHolidays',
      path: getPath('cincinnati', { category: 46 }),
    },
    {
      title: 'teens',
      path: getPath('cincinnati', { target_age: 2 }),
    },
    {
      title: 'volunteerism',
      path: getPath('cincinnati', { type: isTestEnv() ? 94 : 115 }),
    },
    {
      title: 'health-wellness',
      path: getPath('cincinnati', { category: 52 }),
    },
    {
      title: 'history',
      path: getPath('cincinnati', { category: 53 }),
    },
  ],
  miami: [
    {
      title: 'artsAndCulture',
      path: getPath('miami', { category: 2 }),
    },
    {
      title: 'israel',
      path: getPath('miami', { category: 55 }),
    },
    {
      title: 'jewishHolidays',
      path: getPath('miami', { category: 46 }),
    },
    {
      title: 'teens',
      path: getPath('miami', { target_age: 2 }),
    },
    {
      title: 'volunteerism',
      path: getPath('miami', { type: isTestEnv() ? 94 : 115 }),
    },
    {
      title: 'health-wellness',
      path: getPath('miami', { category: 52 }),
    },
    {
      title: 'history',
      path: getPath('miami', { category: 53 }),
    },
  ],
  'silicon-valley': [
    {
      title: 'artsAndCulture',
      path: getPath('silicon-valley', { category: 2 }),
    },
    {
      title: 'israel',
      path: getPath('silicon-valley', { category: 55 }),
    },
    {
      title: 'jewishHolidays',
      path: getPath('silicon-valley', { category: 46 }),
    },
    {
      title: 'teens',
      path: getPath('silicon-valley', { target_age: 2 }),
    },
    {
      title: 'volunteerism',
      path: getPath('silicon-valley', { type: isTestEnv() ? 94 : 115 }),
    },
    {
      title: 'health-wellness',
      path: getPath('silicon-valley', { category: 52 }),
    },
    {
      title: 'history',
      path: getPath('silicon-valley', { category: 53 }),
    },
  ],
  toronto: [
    {
      title: 'artsAndCulture',
      path: getPath('toronto', { category: 2 }),
    },
    {
      title: 'israel',
      path: getPath('toronto', { category: 55 }),
    },
    {
      title: 'jewishHolidays',
      path: getPath('toronto', { category: 46 }),
    },
    {
      title: 'teens',
      path: getPath('toronto', { target_age: 2 }),
    },
    {
      title: 'volunteerism',
      path: getPath('toronto', { type: isTestEnv() ? 94 : 115 }),
    },
    {
      title: 'health-wellness',
      path: getPath('toronto', { category: 52 }),
    },
    {
      title: 'history',
      path: getPath('toronto', { category: 53 }),
    },
  ],
  'northern-virginia': [
    {
      title: 'artsAndCulture',
      path: getPath('northern-virginia', { category: 2 }),
    },
    {
      title: 'israel',
      path: getPath('northern-virginia', { category: 55 }),
    },
    {
      title: 'jewishHolidays',
      path: getPath('northern-virginia', { category: 46 }),
    },
    {
      title: 'teens',
      path: getPath('northern-virginia', { target_age: 2 }),
    },
    {
      title: 'volunteerism',
      path: getPath('northern-virginia', { type: isTestEnv() ? 94 : 115 }),
    },
    {
      title: 'health-wellness',
      path: getPath('northern-virginia', { category: 52 }),
    },
    {
      title: 'history',
      path: getPath('northern-virginia', { category: 53 }),
    },
  ],
};
